import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const TrafficConeIllustration = ({ width = 36, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M156.733 156.667H43.2667C37.7807 156.667 33.3334 161.114 33.3334 166.6V166.734C33.3334 172.22 37.7807 176.667 43.2667 176.667H156.733C162.219 176.667 166.667 172.22 166.667 166.734V166.6C166.667 161.114 162.219 156.667 156.733 156.667Z"
        fill="#D64F15"
      />
      <path
        d="M152.367 156.667H47.6334L87.4334 32.5002C89.1668 27.0335 94.2668 23.3335 100 23.3335C105.733 23.3335 110.8 27.0335 112.567 32.5002L152.367 156.667Z"
        fill="#FF7236"
      />
      <path d="M113.567 35.6333L84.1334 42.8333L71.5334 82.1666L123.967 68.1333L113.567 35.6333Z" fill="#ECECEC" />
      <path
        d="M59.4334 119.834L47.6334 156.667H57.9334L143.967 130.467L133.633 98.3003L59.4334 119.834Z"
        fill="#ECECEC"
      />
    </svg>
  </DefaultIconWrapper>
);
